import React from 'react';
import Slider from 'react-slick';
import CourseCard from '../../Reusable/CourseCard';

const baseSettings = {
  dots: false,
  infinite: true,
  speed: 600,
  slidesToShow: 4,
  slidesToScroll: 1,
  arrows: true,
  autoplay: true,
  autoplaySpeed: 3500,
  pauseOnHover: true,
  responsive: [
    { breakpoint: 1400, settings: { slidesToShow: 3 } },
    { breakpoint: 992, settings: { slidesToShow: 2 } },
    { breakpoint: 576, settings: { slidesToShow: 1 } },
  ],
};

const CourseSlider = ({ title, courses, viewAllLabel }) => {
  if (!courses.length) return null;

  // Clamp slidesToShow to the slide count so a short list doesn't leave empty gaps.
  const settings = {
    ...baseSettings,
    slidesToShow: Math.min(baseSettings.slidesToShow, courses.length),
    responsive: baseSettings.responsive.map((bp) => ({
      ...bp,
      settings: {
        ...bp.settings,
        slidesToShow: Math.min(bp.settings.slidesToShow, courses.length),
      },
    })),
  };

  return (
    <div className="course-category-block">
      {title && (
        <div className="course-category-header">
          <h3>{title}</h3>
          {viewAllLabel && (
            <span className="course-view-all">
              {viewAllLabel}
              <i className="bi bi-arrow-right"></i>
            </span>
          )}
        </div>
      )}
      <div className="course-slider-wrapper">
        <Slider {...settings}>
          {courses.map((course) => (
            <div key={course.id} className="course-slide-pad">
              <CourseCard course={course} />
            </div>
          ))}
        </Slider>
      </div>
    </div>
  );
};

export default CourseSlider;
